import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { eSideDrawerContentType } from '../../types/sideDrawer/eSideDrawerContentType';

interface SideDrawerState {
  contentType?: eSideDrawerContentType;
}

const initialState = { contentType: undefined } as SideDrawerState;

export const sideDrawerSlice = createSlice({
  name: 'sideDrawer',
  initialState,
  reducers: {
    setSideDrawer(state, action: PayloadAction<eSideDrawerContentType>) {
      state.contentType = action.payload;
    },
    closeSideDrawer(state) {
      state.contentType = undefined;
    },
  },
});

export const { setSideDrawer, closeSideDrawer } = sideDrawerSlice.actions;
